/** Known mutation signatures from the uploaded detail screen. No guessed API-slice exports. */
export function invokeAction(action, id, payload = {}, mutations) {
 if (!id) throw new Error('A campaign id is required.');
 const fn = mutations[action];
 if (typeof fn !== 'function') throw new Error('This action is not available.');
 if (['start', 'resume', 'submit'].includes(action)) return fn(id);
 return fn({ id, ...payload });
}
export function errorCode(error) { return error?.data?.error ?? error?.body?.error ?? error?.code ?? ''; }
export function ambiguousActionError(error) {
 const code = errorCode(error);
 if (['PLANNER_UNAVAILABLE', 'PLANNER_QUEUE_FAILED', 'CAMPAIGN_AGENDA_DISABLED', 'INVALID_CAMPAIGN'].includes(code)) return false;
 return ['FETCH_ERROR', 'TIMEOUT_ERROR', 'PARSING_ERROR'].includes(error?.status)
  || Number(error?.status) >= 500 || error?.name === 'TypeError' || error?.name === 'AbortError';
}
export function unwrapRequest(request) {
 return request && typeof request.unwrap === 'function' ? request.unwrap() : Promise.resolve(request);
}
